import { StyleSheet, View } from 'react-native'
import { useBackdropBlur } from '../providers/NativeCapabilitiesContext'
import { useTheme } from '../theme/restyle'
import { isDarkColor } from '../theme/isDarkColor'
import { withAlpha } from '../utils/withAlpha'

/** KYC uses a near-opaque material for identity details and receipts. */
export function KycGlassBackdrop() {
  const theme = useTheme()
  const renderBlur = useBackdropBlur()
  const color = isDarkColor(theme.background.modal)
    ? theme.background.modal
    : '#FFFFFF'
  return (
    <View pointerEvents="none" style={StyleSheet.absoluteFill}>
      {renderBlur()}
      <View
        style={[
          StyleSheet.absoluteFill,
          { backgroundColor: withAlpha(color, 0.98) },
        ]}
      />
    </View>
  )
}
